import { ChainId } from '../constant';
import { Client } from './type';

const exchangeGraph = process.env.REACT_APP_EXCHANGE_GRAPH;
const onePieceServer = process.env.REACT_APP_ONE_PIECE_SERVER_GRAPHQL_ENDPOINT;

export default {
    [ChainId.mainnet]: {
        [Client.onePieceServer]: onePieceServer || '',
        [Client.exchangeSubgraph]: exchangeGraph || '',
    },
    [ChainId.testnet]: {
        [Client.onePieceServer]: onePieceServer || '',
        [Client.exchangeSubgraph]: exchangeGraph || '',
    },
};
